export const BRAND_LOGO_SQUARE = new URL('./assets/logo_transparent_square.png', import.meta.url).href;
export const BRAND_LOGO_BACKGROUND = new URL('./assets/logo_background.png', import.meta.url).href;

